import { type ActivityLogger } from '@databases/logs/activity-logger';
import {
  type PanelKeyToPropsMapping,
  type PanelKeys,
  PanelManager,
} from '@databases/panel-types';

/**
 * Panel manager for modes where the panel mounts inline inside the Databases app
 * (e.g. standalone), rather than in an external host container.
 */
export class LocalPanelManager extends PanelManager {
  constructor(private readonly activityLogger: ActivityLogger) {
    super();
  }

  public override showPanel<key extends PanelKeys>(
    panelKey: key,
    data?: PanelKeyToPropsMapping[key]
  ) {
    this.state.panel = panelKey;
    this.state.data = data;

    this.activityLogger.log('showPanel', { panelKey: this.state.panel, ...data });
  }

  public override hidePanel() {
    this.activityLogger.log('hidePanel', { panelKey: this.state.panel });

    this.state.panel = null;
    this.state.data = undefined;
  }
}
